export default __webpack_public_path__ + "static/media/39_desktop.10ae39c5.jpg";